import React from 'react';
import classes from "./ExpertiseSection.module.css";
import { Col, Container, Row } from 'react-bootstrap';
import SectionHeader from '../../components/SectionHeader';
import Image from "../../assets/images/expertise.png";
import { Expertise } from '../../data/app-data';
import { BsDot } from "react-icons/bs";

export default function ExpertiseSection() {
  return (
    <Container>
      <Row className='gy-4'>
        <Col md={6}>
          <div className={classes.imageDiv}>
            <img src={Image} alt="img" className={classes.image} />
          </div>
        </Col>
        <Col md={6} className={classes.contentDiv}>
          <SectionHeader title={"Our Expertise"} heading={"Your goals, our mission"} headingWhite />
          <p className="f-14 mb-3">{`Why rely on ARK Accounting Group for your strategic needs`}</p>
            {Expertise?.map((e, i) => {
              return (
                <p key={i} className={`${classes.list} f-16 fw-500`}> <BsDot size={25}/>{e?.list}</p>
              )
            })}
        </Col>
      </Row>
    </Container>
  )
}
